import React, { useEffect, useState, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "antd";
import { HamburguerMenu, ArrowBackMenu, LogoLoganMenu } from "assets/icons/index";
import { menuList } from "components/layout/menuListItem";
import cookie from "js-cookie";
import { MenuItemActive } from "store/user-session/user-session-model";
import useTranslation from "utils/hooks/useTranslation";
import CardContent from "./CardContent";
import * as S from "./styled/sidebar.styled";

interface AuxProps {
  isLoading: boolean;
  role: string;
  menuItemActive?: MenuItemActive;
  isCollapseSidebar?: boolean;
  hasAttendance?: boolean;
  hasRfidReading?: boolean;
  userSessionCollapseSidebar?: () => void;
  userSessionUncollapseSidebar?: () => void;
  userSessionMenuItemActive?: (...args) => void;
  children?: ReactNode;
}

const SideBar: React.FC<AuxProps> = (props) => {
  const {
    children,
    isLoading,
    role,
    isCollapseSidebar,
    hasAttendance,
    hasRfidReading,
    menuItemActive,
    userSessionCollapseSidebar,
    userSessionUncollapseSidebar,
    userSessionMenuItemActive,
  } = props;
  const [collapsed, setCollapsed] = useState(isCollapseSidebar);
  const [openKeys, setOpenKeys] = useState([]);
  const ITEM = (label) => useTranslation({ id: label });
  const router = useNavigate();

  useEffect(() => {
    setOpenKeys(collapsed ? [] : ["2", "3", "16"]);
  }, [collapsed]);

  const collapseSidebar = () => {
    setCollapsed(!collapsed);
    userSessionCollapseSidebar();
  };

  const unCollapseSidebar = () => {
    setCollapsed(!collapsed);
    userSessionUncollapseSidebar();
  };

  const CustomTrigger = () => (
    <S.LogoSidebar>
      {collapsed === false ? (
        <>
          <S.ButtonArrowBack onClick={() => collapseSidebar()} data-testid="uncollapseSidebar">
            <ArrowBackMenu className="arrowBackIcon" />
          </S.ButtonArrowBack>
          <S.LineDividerSidebar type="vertical" orientation="center" />
          <LogoLoganMenu className="logoIcon" />
        </>
      ) : (
        <button onClick={() => unCollapseSidebar()} data-testid="collapseSidebar" className="hamburguerButton">
          <HamburguerMenu className="hamburguerIcon" />
        </button>
      )}
    </S.LogoSidebar>
  );

  const getActiveMenuItem = () => {
    const { icon, title } = getPath(menuList, menuItemActive);
    return { Icon: icon, title };
  };

  const onHandlerRedirectPage = (path: string) => {
    router(path, undefined);
  };

  const onClickMenu = (e) => {
    e.domEvent.preventDefault();
    const key = e.key;
    cookie.set("menuItemActive", `${key}`);
    userSessionMenuItemActive(`${key}`);
    const { path } = getPath(menuList, key);
    onHandlerRedirectPage(path);
  };

  const getPath = (menuListPaths, key) => {
    let filter;
    filter = menuListPaths.filter((x) => x.id === key)[0];
    if (filter === undefined) {
      filter = menuListPaths.filter((x) => x.Items?.filter((y) => y.id === key)[0])[0].Items.filter((x) => x.id === key)[0];
    }
    return filter;
  };

  const menuItem = (item) => {
    const Icon = item.icon;
    const isAttendancePage = "12";
    const isReadersAndTagsPage = "16";
    if ((item.id === isAttendancePage && !hasAttendance) || (item.id === isReadersAndTagsPage && !hasRfidReading)) {
      return false;
    }
    return (
      <S.MenuItemLayout key={`${item.id}`} icon={<Icon width="24" height="24" className="iconItem" />}>
        {ITEM(item.label)}
      </S.MenuItemLayout>
    );
  };

  const menuSubItem = (item) => {
    if (item.hideItem === false && item.role.includes(role)) {
      return <S.MenuItemLayout key={`${item.id}`}>{ITEM(item.label)}</S.MenuItemLayout>;
    }
    return null;
  };

  return (
    <Layout style={S.LayoutSidebar}>
      <S.LayoutSider collapsible trigger={null} width="237" collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
        <CustomTrigger />
        <S.MenuLayout mode="inline" onClick={onClickMenu} selectedKeys={[menuItemActive]} openKeys={openKeys} onOpenChange={setOpenKeys}>
          {menuList.map((item) => {
            const Icon = item.icon;
            const isAttendancePage = "12";
            const isReadersAndTagsPage = "16";

            if (item.role.includes(role)) {
              if ((item.id === isAttendancePage && !hasAttendance) || (item.id === isReadersAndTagsPage && !hasRfidReading)) {
                return null;
              }

              if (item.Items === undefined) {
                return menuItem(item);
              } else {
                return (
                  <S.SubMenuItemLayout key={`${item.id}`} icon={<Icon width="24" height="24" className="iconItem" />} title={ITEM(item.label)}>
                    {item.Items && (item.Items as any[]).map((subItem) => menuSubItem(subItem))}
                  </S.SubMenuItemLayout>
                );
              }
            } else {
              return null;
            }
          })}
        </S.MenuLayout>
      </S.LayoutSider>
      <CardContent isLoading={isLoading} {...getActiveMenuItem()}>
        {children}
      </CardContent>
    </Layout>
  );
};

SideBar.defaultProps = {
  isLoading: false,
};

export default SideBar;
